import { oauthTokenSelector } from 'selectors/app'
import { FETCH_CHARGES_REQUEST } from 'ducks/integrations/stripe/types'
import { doSdkRequest } from 'ducks/requests'

import * as api from '../api'

const doFetchCharges = ({ integrationId, customerId, lastItemId }) => {
  return doSdkRequest(
    FETCH_CHARGES_REQUEST,
    async ({ getState }) => {
      const state = getState()
      const token = oauthTokenSelector(state)

      const { response } = await api.getCharges(
        token,
        integrationId,
        customerId,
        lastItemId
      )
      return response
    },
    { integrationId, customerId, lastItemId }
  )
}

export default doFetchCharges
